import { Component, forwardRef, Input } from "@angular/core";
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from "@angular/forms";
import {
  DEFAULT_CHANGE_CALLBACK,
  DEFAULT_TOUCH_CALLBACK,
  OnChangeCallbackType,
  OnTouchCallbackType,
} from "shared/base-components/models/ControlValueAccessorTypes";

const VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => BfxQuickSearchComponent),
  multi: true,
};

/**
 * Component that shows input with a search icon on left and a Clear button that becomes
 * visible when any content is in the input.
 *
 * No debouncing is currently implemented.
 *
 * Use Forms model for communicating all changes.
 */
@Component({
  selector: "bfx-quick-search",
  templateUrl: "./html/bfx-quick-search.html",
  providers: [VALUE_ACCESSOR],
  standalone: false,
})
export class BfxQuickSearchComponent implements ControlValueAccessor {
  private currentValue: string = null;

  /** ControlValueAccessor callback */
  public onModelChange: OnChangeCallbackType = DEFAULT_CHANGE_CALLBACK;

  /** ControlValueAccessor callback */
  public onModelTouched: OnTouchCallbackType = DEFAULT_TOUCH_CALLBACK;

  private disabled: boolean = false;

  constructor() {}

  /**
   * Initialize value from blotter configuration in case this component is attached to
   * blotter filter bar.
   */
  ngOnInit() {}

  public onValueChange(value: string) {
    this.currentValue = value;
    this.onModelChange(value);
  }

  writeValue(value: string): void {
    this.currentValue = value;
  }

  registerOnChange(fn: OnChangeCallbackType): void {
    this.onModelChange = fn;
  }

  registerOnTouched(fn: OnTouchCallbackType): void {
    this.onModelTouched = fn;
  }

  setDisabledState(val: boolean): void {
    this.disabled = val;
  }

  /**
   * Only show icon when there is non-empty string value
   */
  public get clearIconClass(): string {
    if (this.currentValue) {
      return "icon_ion_cancel_filled";
    }
    return null;
  }

  public onClearClick() {
    this.onValueChange("");
  }

  public get searchValue(): string {
    return this.currentValue;
  }

  public set searchValue(value: string) {
    this.onValueChange(value);
  }
}
